/**
 * CategoryFilter — Horizontal pill/chip list for category filtering.
 *
 * Categories come from TokenCategorySchema. "All" is always the first option.
 * Active pill gets a highlighted style.
 *
 * Story 3.4 — Task 4.2
 */

import { TokenCategorySchema } from "@repo/shared-types";

import { cn } from "../../lib/cn";

const CATEGORIES = ["All", ...TokenCategorySchema.options] as const;

type CategoryFilterProps = {
	value: string | undefined;
	onChange: (category: string | undefined) => void;
};

export function CategoryFilter({ value, onChange }: CategoryFilterProps) {
	return (
		<fieldset className="flex flex-wrap gap-2 border-0 p-0 m-0" aria-label="Category filter">
			{CATEGORIES.map((category) => {
				const isActive = category === "All" ? !value : value === category;
				return (
					<button
						key={category}
						type="button"
						onClick={() => onChange(category === "All" ? undefined : category)}
						className={cn(
							"px-3 py-1.5 rounded-full text-xs font-medium transition-colors",
							isActive
								? "bg-pastel-vibrant-blue text-white"
								: "bg-pastel-light-gray text-pastel-gray hover:bg-pastel-border hover:text-pastel-black"
						)}
					>
						{category}
					</button>
				);
			})}
		</fieldset>
	);
}
